import {
  addItemToCollection,
  getItemFromCollection,
  updateItemInCollection,
} from "directus/src/operations";
import { CHALLENGES_COLLECTION } from "../../constants";

export async function fetchChallenge({ challengeId }) {
  return getItemFromCollection(CHALLENGES_COLLECTION, challengeId, {
    fields: ["id", "challenge", "solution"],
  });
}

export async function createChallenge({ item }) {
  return addItemToCollection(CHALLENGES_COLLECTION, item);
}

export async function updateChallenge({ challengeId, item }) {
  return updateItemInCollection(CHALLENGES_COLLECTION, challengeId, item);
}
